import './layoutHooksRegistrar'
import './componentHooksRegistrar'
import './metaDataHooksRegistrar'

export default {}
